import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useFindEwallets = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("GET");
  
  const useGetFindEwallets = async () => await makeApiRequest(`${apiBase}/api/wallets`, {});
  return [useGetFindEwallets];
};

export default useFindEwallets;
